import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@14.2.35_@babel+core@7.28.3_@opentelemetry+api@1.9.0_@playwright+test@1.58.2_react-_f5ea6806f62c85ac599a5de481aebf07/node_modules/next/dist/client/link.js");
